import OutboundLink from 'components/OutboundLink';
import './AcrisLinks.css';

/**
 * Opens the ACRIS document detail page in a new tab.
 */
function AcrisDetailLink(props) {
	const { text } = props;
	if (!text) {
		return '—';
	}

	return (
		<OutboundLink
			url={text}
			className="d-flex justify-content-center acris-detail-link"
		>
			<i className="bi bi-file-earmark-text" title="View document detail" />
		</OutboundLink>
	);
}

export default AcrisDetailLink;
